import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Services() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate({ pathname: "/", hash: "services" }, { replace: true });
  }, [navigate]);
  return null;
}
